import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChecklistFormComponent } from '../checklist/checklist-form/checklist-form.component';
import { BulletinComponent } from '../home/bulletin/bulletin.component';
import { DirectDepositComponent } from './direct-deposit/direct-deposit.component';
import { EmergencyContactsComponent } from './emergency-contacts/emergency-contacts.component';
import { Filli9Component } from './filli9/filli9.component';
import { ReviewW4ModalComponent } from 'src/app/modals/hiring/review-w4-modal/review-w4-modal.component';
import { IdentificationComponent } from './identification/identification.component';
import { TasksComponent } from './tasks/tasks.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { BrowseJobsComponent } from './browse-jobs/browse-jobs.component';
import { JobDetailsComponent } from './job-details/job-details.component';

const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    path: 'tasks',
    component: TasksComponent,
  },
  {
    path: 'fillw4',
    component: ReviewW4ModalComponent,
  },
  {
    path: 'filli9',
    component: Filli9Component,
  },
  {
    path: 'identification',
    component: IdentificationComponent,
  },
  {
    path: 'directdeposit',
    component: DirectDepositComponent,
  },
  {
    path: 'emergencycontacts',
    component: EmergencyContactsComponent,
  },
  {
    path: 'onboardingdocument/:bulletinID',
    component: BulletinComponent,
  },
  {
    path: 'onboardingform/:checklistInstanceID',
    component: ChecklistFormComponent,
  },
  {
    path: 'browsejobs',
    component: BrowseJobsComponent,
  },
  {
    path: 'jobdetails/:reqID',
    component: JobDetailsComponent,
  },
  {
    path: 'jobdetails',
    component: JobDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CareersRoutingModule {}
